<div class="step-final">
  <p>{{ 'PARTNER.WIZARD.SUB_FINAL_STEP.USER_CAN' | translate }}</p>

  <!--begin::Wizard Buttons-->
  <button mat-raised-button (click)="onNextStep()">
    {{ 'PARTNER.WIZARD.CLOSE' | translate }}
  </button>
  <!--end::Wizard Buttons-->

</div>